module.exports = __webpack_public_path__ + "static/icons/icon-webcam-85ee002634fd1fbf4e78363f0859b821.svg";